// Test IDs for the client corporate portal (/portal/*).
export const PORTAL = {
  // Login
  loginEmailInput: 'portal-login-email-input',
  loginPasswordInput: 'portal-login-password-input',
  loginSubmitButton: 'portal-login-submit-button',
  loginError: 'portal-login-error',
  loginLogo: 'portal-login-logo',
  loginForgotPasswordLink: 'portal-login-forgot-password-link',

  // Layout
  headerClienteName: 'portal-header-cliente-name',
  headerLogoutButton: 'portal-header-logout-button',
  headerCuentaLink: 'portal-header-cuenta-link',

  // Mi cuenta (cambiar contraseña)
  cuentaCurrentPasswordInput: 'portal-cuenta-current-password-input',
  cuentaNewPasswordInput: 'portal-cuenta-new-password-input',
  cuentaConfirmPasswordInput: 'portal-cuenta-confirm-password-input',
  cuentaSubmitButton: 'portal-cuenta-submit-button',
  cuentaError: 'portal-cuenta-error',
  cuentaSuccess: 'portal-cuenta-success',

  // Unidades (mis unidades)
  summaryTotal: 'portal-summary-total',
  summaryEnCurso: 'portal-summary-en-curso',
  summaryEntregadas: 'portal-summary-entregadas',
  searchInput: 'portal-search-input',
  filterEtapa: 'portal-filter-etapa',
  filterTipo: 'portal-filter-tipo',
  unidadCard: 'portal-unidad-card',
  emptyState: 'portal-empty-state',
};
